import React, { useMemo } from "react";
import PropTypes from "prop-types";
import IconGlyph from "@/bit/components/next13.components.icon-glyph";
import Text from "@/bit/components/next13.components.text";
import CustomLink from "@/bit/components/next13.components.custom-link";
import { grid, colors } from "../../constants";

const AuxiliaryBubble = ({ icon, index, text, onClick, position, isActive, taggingInfo }) => {
  const glyph = useMemo(() => <IconGlyph {...icon} className="icon-nohover" />, [icon.id]);
  const glyphHover = useMemo(
    () => <IconGlyph {...icon} color="white" className="icon-hover" />,
    [icon.id]
  );
  return (
    <>
      <CustomLink
        taggingInfo={{
          ...taggingInfo,
          eventType: "click",
          componentName: "Ecosystem",
          componentContent: text.text,
        }}
        onClick={() => onClick(index)}
        cyData="Ecosystem Auxiliary Bubble"
      >
        <div className="auxiliary-bubble">
          <div
            className={`bubble${isActive ? " is-active" : ""}`}
            data-cy="Ecosystem Auxiliary Bubble Icon"
          >
            {glyph}
            {glyphHover}
          </div>
          <div className="outer-bubble"></div>
          <div className="border"></div>
          <div className="text-container">
            <Text
              {...text}
              kind="span"
              size="caption02"
              fontType="fontype-light"
              cyData="Ecosystem Auxiliary Bubble Title"
            />
          </div>
        </div>
      </CustomLink>
      <style jsx>
        {`
          .auxiliary-bubble {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            position: absolute;
            transform: translate(-50%, -50%);
            z-index: 1;
            cursor: pointer;
            top: ${50 + position.x}%;
            left: ${50 + position.y}%;

            .bubble {
              width: 3.75rem;
              height: 3.75rem;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: ${isActive ? colors.color_gp__blue : "#e6f5fd"};
              margin-bottom: 0.375rem;
              position: relative;
              transform: scale(${isActive ? 80 : 100}%);
              transition: all 300ms ease-in-out;
              ${isActive ? "box-shadow: rgba(255, 255, 255, 0.3) 0 0 10px;" : ""}

              border-width: 2px;
              border-color: ${isActive ? "rgba(230, 245, 253, 0.4295)" : "rgb(2 136 210 / 20%)"};
              border-style: solid;

              :global(.icon-hover) {
                display: none;
              }

              :global(.svg-layout-size) {
                width: 30px !important;
                height: 30px !important;
              }
              & > :global(.icon-hover) {
                display: ${isActive ? "block" : "none"};
              }
              & > :global(.icon-nohover) {
                display: ${isActive ? "none" : "block"};
              }
            }

            .outer-bubble {
              width: 3.75rem;
              height: 3.75rem;
              position: absolute;
              top: 0;
              border-radius: 100%;
              z-index: -1;
              background-color: #019ff469;
            }

            .text-container {
              position: absolute;
              transform: translate(-50%, 100%);
              bottom: 0;
              left: 50%;
              :global(.text) {
                line-height: 0.8rem;
              }
            }
          }

          // Tablet
          @media screen and (min-width: ${grid.breakpoint_sm}px) {
            .auxiliary-bubble {
              .bubble {
                width: min(5rem, 7vw);
                height: min(5rem, 7vw);

                :global(.svg-layout-size) {
                  width: 32px !important;
                  height: 32px !important;

                  & > :global(img) {
                    width: 32px !important;
                    height: 32px !important;
                  }
                }
              }

              .outer-bubble {
                width: min(5rem, 7vw);
                height: min(5rem, 7vw);
              }
            }
          }
          // Desktop
          @media screen and (min-width: ${grid.breakpoint_md}px) {
            .auxiliary-bubble {
              .bubble {
                width: min(5rem, 7vw);
                height: min(5rem, 7vw);

                :global(.svg-layout-size) {
                  width: 32px !important;
                  height: 32px !important;

                  & > :global(svg) {
                    width: 32px !important;
                    height: 32px !important;
                  }
                }
              }

              .outer-bubble {
                width: min(5rem, 7vw);
                height: min(5rem, 7vw);
              }

              &:hover {
                .bubble {
                  transform: scale(80%);
                  background-color: ${colors.color_gp__blue};
                  :global(.icon-hover) {
                    display: block;
                  }

                  :global(.icon-nohover) {
                    display: none;
                  }
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

AuxiliaryBubble.propTypes = {};

export default AuxiliaryBubble;
